// AC5: Renders a single importance tag chip
// tag_type drives visual treatment: preset (blue), system (purple), custom (teal)

import { GrievanceTag } from '../services/InstituteAdminGrievanceService';

const TAG_STYLES: Record<string, { bg: string; text: string; border: string }> = {
    preset: { bg: '#dbeafe', text: '#1d4ed8', border: '#bfdbfe' },
    system: { bg: '#ede9fe', text: '#6d28d9', border: '#ddd6fe' },
    custom: { bg: '#ccfbf1', text: '#0f766e', border: '#99f6e4' },
};

const TagChip = ({ tag }: { tag: GrievanceTag }) => {
    const style = TAG_STYLES[tag.tagType] ?? TAG_STYLES['custom'];
    return (
        <span
            className="badge rounded-pill font-500 px-2 py-1 border"
            style={{ backgroundColor: style.bg, color: style.text, borderColor: style.border }}
        >
            {tag.tagLabel}
        </span>
    );
};

export default TagChip;
